<template>
  <div class="wl-matter-log-add-edit-container">

    <!-- save and cancel btns -->
    <div class="wl-matter-log-add-edit-btns">
      <el-button v-if="data.user.userType == '1'"
                 :loading="saveLoading"
                 type="primary"
                 @click="onConfirm"
                 class="wl-green">{{$t('btn_save')}}
      </el-button>
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}
      </el-button>
    </div>
    <div class="formCenter">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="200px"
               class="wl-form">
        <!-- row 1 -->

        <el-row type="flex"
                class="row-bg">
          <el-col :span="8">
            <el-form-item :label="$t('TABLE_HEADER_matter')"
                          prop="title">
              <el-input class="wl-form-item input-with-select"
                        :disabled="data.user.userType == '2'"
                        maxlength="50"
                        v-model="ruleForm.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('TABLE_HEADER_category_placeholder')"
                          prop="category">
              <select-multi class="wl-form-item"
                            :disabled="!data.isNew&&data.user.userType == '2'"
                            :api="selectCategory"
                            :onChanage="onCategoryChange"
                            :filterable="true"
                            v-model="ruleForm.category"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('FORM_LABEL_matterType')"
                          prop="matterType">
              <select-multi class="wl-form-item"
                            :disabled="!data.isNew&&data.user.userType == '2'"
                            :api="selectMatter"
                            :onChanage="onMatterTypeChange"
                            v-model="ruleForm.matterType"/>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- row 2 -->
        <el-row type="flex"
                class="row-bg">
          <el-col :span="8">
            <el-form-item :label="$t('FORM_LABEL_Organization')"
                          prop="organization">
              <el-select
                  v-model="ruleForm.organization"
                  multiple
                  collapse-tags
                  class="wl-form-item input-with-select"
                  @onChanage="onOrganizationChange"
                  clearable
                  filterable>
                <el-option v-for="item in organizationList"
                           :key="item.id"
                           :label="item.entityName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('FORM_LABEL_kpmgOwner')"
                          prop="kpmgOwner">
              <el-select :disabled="!data.isNew&&data.user.userType == '2'"
                         class="wl-form-item input-with-select"
                         @onChanage="onKPMGOwnerChange"
                         v-model="ruleForm.kpmgOwner"
                         filterable>
                <el-option v-for="item in kpmgOwnerList"
                           :key="item.id"
                           :label="item.userName+' ( '+item.profitCenter +' ) '"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('FORM_LABEL_clientOwner')"
                          prop="clientOwner">
              <el-select :disabled="!data.isNew&&data.user.userType == '2'"
                         class="wl-form-item input-with-select"
                         @onChanage="onClientOwnerChange"
                         v-model="ruleForm.clientOwner"
                         filterable>
                <el-option v-for="item in clientOwnerList"
                           :key="item.userId"
                           :label="item.userName"
                           :value="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- row 3 -->
        <el-row type="flex"
                class="row-bg">
          <el-col :span="8">
            <el-form-item :label="$t('TABLE_HEADER_Issues')"
                          prop="status">
              <el-select :disabled="!data.isNew&&data.user.userType == '2'"
                         class="wl-form-item input-with-select"
                         @onChanage="onStatusChange"
                         v-model="ruleForm.status"
                         filterable>
                <el-option v-for="item in statusList"
                           :key="item.value"
                           :label="$t(item.label)"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('FORM_LABEL_priority')"
                          prop="priority">
              <select-multi :disabled="!data.isNew&&data.user.userType == '2'"
                            class="wl-form-item wl-form-item"
                            :api="selectPriority"
                            :onChanage="onPriorityChange"
                            v-model="ruleForm.priority"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex"
                class="row-bg">
          <el-col :span="24">
            <el-form-item :label="$t('TABLE_HEADER_Description_placeholder')"
                          prop="description">
              <el-input style="width: 80%"
                        class="input-with-select"
                        type='textarea'
                        maxlength="1000"
                        show-word-limit
                        :disabled="!data.isNew&&data.user.userType == '2'"
                        :rows="7"
                        v-model="ruleForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
    import SelectMulti from '@/components/common/SelectMulti'
    import SelectAd from '@/components/common/selectAd'
    import MComments from './comments'
    import * as _ from 'lodash'
    import API from '@/api'
    import requestUrl from '@/api/requestUrl'
    import {checkIsValidExtension} from '@/utils/fileType'
    import { loading, isIE, UserInput } from '@/utils'
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                headers: {},
                imageName: '',
                actionUrl: requestUrl('/client/clientMatterLog/uploadMatterFile'),
                organizationList: [],
                kpmgOwnerList: [],
                clientOwnerList: [],
                statusList: [],
                relatedIssueList: [],
                ruleForm: {
                    title: '',
                    matterType: '',
                    category: '',
                    organization: [],
                    kpmgOwner: '',
                    clientOwner: '',
                    status: '',
                    priority: null,
                    relatedIssue: [],
                    description: '',
                    attachmentList: []
                },
                saveLoading: false,
                commentList: [],
                fileList: []
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite'
            }),
            rules() {
                const rules = {
                    title: [
                        {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'},
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        }
                    ],
                    category: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}],
                    organization: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}],
                    status: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}],
                }
                return rules
            }
        },
        methods: {
            handleRemove(file) {
                if (file.status == 'success') {
                    this.ruleForm.attachmentList.forEach((item, index) => {
                        if (item.id == file.id || item.id == (file.response && file.response.data)) {
                            this.ruleForm.attachmentList.splice(index, 1)
                        }
                    })
                    this.getFileName()
                }
            },
            async download(file) {
                const params = {
                    fileId: file.id ? file.id : file
                }
                let service = loading()
                try {
                    service.download()
                    const res = await API.matterLogs.downloadMatterFiles({
                        siteId: this.getSite.siteId,
                        ...params
                    })
                    if (/application\/json/.test(res.type)) {

                        let reader = new FileReader()
                        reader.onload = e => {
                            if (e.target.readyState === 2) {
                                let resJson = {}
                                resJson = JSON.parse(e.target.result)
                                this.$message.error({duration: 5000, message: this.$t(resJson.code)})
                            }
                        }
                        reader.readAsText(res)
                    } else if (/application\/octet-stream/.test(res.type)) {

                        let blob = new Blob([res])
                        if (isIE()) {
                            navigator.msSaveBlob(blob, file.name)
                        } else {
                            let url = window.URL.createObjectURL(blob)
                            let link = document.createElement('a')
                            link.style.display = 'none'
                            link.href = url
                            link.setAttribute('download', file.name)
                            document.body.appendChild(link)
                            link.click()
                        }
                    }
                }
                catch(e) {}
                finally {
                    service.close()
                }
            },
            handleClick(file) {
                if (file.status == 'success') {
                    this.download(file)
                }
            },
            getFileName() {
                this.imageName = ''
                this.ruleForm.attachmentList.forEach(i => {
                    this.imageName = this.imageName + i.name + '; '
                })
            },
            handleAvatarSuccess(res, file, files) {
                if (res.code == '1') {
                    const fileItem = {
                        id: res.data,
                        name: file.name,
                        uploadBy: this.getUser.profitCenter ? this.getUser.userName + ' (' + this.getUser.profitCenter + ')' : this.getUser.userName
                    }
                    this.ruleForm.attachmentList.push(fileItem)
                    const showItem = Object.assign(fileItem)
                    showItem.name = showItem.uploadBy + '-' + showItem.name
                    this.fileList = this.fileList.concat([showItem])
                    this.getFileName()
                } else {
                    files.forEach((i, n) => {
                        if (i.uid == file.uid) {
                            files.splice(n, 1)
                        }
                    })
                    this.$message.error('"' + file.name + '"' + '  ' + this.$t('file_upload_failed') + '  ' + this.$t(res.code))
                }
            },
            submitUpload() {
                this.$refs.upload.submit()
            },
            beforeAvatarUpload(file) {
                const isJPG = checkIsValidExtension(file.name);
                const isLt1G = file.size / 1024 / 1024 / 1024 < 1
                if (!isJPG) {
                    this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_TYPE'))
                }
                if (!isLt1G) {
                    this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_SIZE'))
                }
                return isJPG && isLt1G
            },
            selectMatter: () => API.matterLogs.queryMatterLogTypeDescs({}),
            addMatterLog() {
                this.saveLoading = !this.saveLoading
                const params = {
                    siteId: this.data.siteId,
                    title: this.ruleForm.title,
                    typeDesc: this.ruleForm.matterType,
                    category: this.ruleForm.category,
                    auditType: this.data.auditType,
                    matterDesc: this.ruleForm.description,
                    kpmgUser: {
                        id: this.ruleForm.kpmgOwner
                    },
                    clientUser: {
                        id: this.ruleForm.clientOwner
                    },
                    matterStatus: this.ruleForm.status,
                    matterPriority: this.ruleForm.priority,
                    releatedMatterLogList: this.ruleForm.relatedIssue,
                    entityIdList: this.ruleForm.organization,
                    attachmentList: this.ruleForm.attachmentList
                }
                API.matterLogs
                    .addMatterLog(params)
                    .then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.saveLoading = !this.saveLoading
                            this.onCancel()
                            this.onRefresh()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch(e => {
                        console.error(e);
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.saveLoading = !this.saveLoading
                    })
            },
            updateMatterLogClient() {
                this.saveLoading = !this.saveLoading
                const params = {
                    id: this.data.id,
                    title: this.ruleForm.title,
                    releatedMatterLogList: this.ruleForm.relatedIssue
                }
                API.matterLogs
                    .clientUpdateMatterLog(params)
                    .then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.saveLoading = !this.saveLoading
                            this.onCancel()
                            this.onRefresh()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch(e => {
                        console.error(e);
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.saveLoading = !this.saveLoading
                    })
            },
            updateMatterLogKp() {
                this.saveLoading = !this.saveLoading
                const params = {
                    id: this.data.id,
                    title: this.ruleForm.title,
                    typeDesc: this.ruleForm.matterType,
                    category: this.ruleForm.category,
                    matterDesc: this.ruleForm.description,
                    kpmgUser: {
                        id: this.ruleForm.kpmgOwner
                    },
                    clientUser: {
                        id: this.ruleForm.clientOwner
                    },
                    matterStatus: this.ruleForm.status,
                    matterPriority: this.ruleForm.priority,
                    releatedMatterLogList: this.ruleForm.relatedIssue,
                    attachmentList: this.ruleForm.attachmentList,
                    entityIdList: this.ruleForm.organization,
                    siteId: this.getSite.siteId,
                }
                const categoryObj = this.matterlogCategorys.find(v => v.label == this.ruleForm.category)
                if (categoryObj && categoryObj.value) params.category = categoryObj.value
                API.matterLogs
                    .kpUpdateMatterLog(params)
                    .then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.saveLoading = !this.saveLoading
                            this.onCancel()
                            this.onRefresh()
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch(e => {
                        console.error(e);
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.saveLoading = !this.saveLoading
                    })
            },
            onConfirm() {
                this.$refs.ruleForm.validate(validate => {
                    if (validate) {
                        if (this.data.isNew) {
                            this.addMatterLog()
                        } else if (this.data.user.userType == '1') {
                            this.updateMatterLogKp()
                        } else if (this.data.user.userType == '2') {
                            this.updateMatterLogClient()
                        }
                    }
                })
            },
            selectCategory: () => API.matterLogs.queryMatterLogCategory({}),
            async getcategoryOptions() {
                const {code, data} = await API.matterLogs.queryMatterLogCategory({})
                this.matterlogCategorys = data
            },
            selectOrganization() {
                API.matterLogs.queryEntitys({siteId: this.data.siteId}).then(res => {
                    if (res.code == '1') {
                        this.organizationList = res.data
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            },
            selectKPOwner() {
                API.matterLogs.searchKpmgOwner({siteId: this.data.siteId, searchContent: ''}).then(res => {
                    if (res.code == '1') {
                        this.kpmgOwnerList = res.data
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            },
            selectClientOwner() {
                API.matterLogs.searchClientOwner({siteId: this.data.siteId, searchContent: ''}).then(res => {
                    if (res.code == '1') {
                        this.clientOwnerList = res.data
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            },
            selectPriority: () => API.matterLogs.queryMatterLogPriority({
                blankFlag:1
            }),
            selectRelatedIssue() {
                API.matterLogs.queryRelatedIssues({siteId: this.data.siteId}).then(res => {
                    if (res.code == '1') {
                        this.relatedIssueList = res.data
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            },
            getComments(attachmentList) {
                if (attachmentList && attachmentList.length > 0) {
                    this.fileList = this.fileList.concat(this.initFileList(attachmentList))
                }
                const params = {
                    id: this.data.id
                }
                API.matterLogs.queryComments(params).then(res => {
                    if (res.code == '1') {
                        this.commentList = Object.assign({}, res.data)
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            },
            validateHander(attr) {
                if (this.$refs.ruleForm) {
                    // this.ruleForm[attr] = '1';
                    this.$$nextTick(() => this.$refs.ruleForm.validateField(attr))
                }
            },
            onMatterTypeChange(v) {
                this.ruleForm.matterType = v
                this.$refs.ruleForm.validateField('matterType')
            },
            onCategoryChange(v) {
                this.ruleForm.category = v
                this.$refs.ruleForm.validateField('category')
            },
            onOrganizationChange(v) {
                this.ruleForm.organization = v
                this.$refs.ruleForm.validateField('organization')
            },
            onKPMGOwnerChange(v) {
                this.ruleForm.kpmgOwner = v
                this.$refs.ruleForm.validateField('kpmgOwner')
            },
            onClientOwnerChange(v) {
                this.ruleForm.clientOwner = v
                this.$refs.ruleForm.validateField('clientOwner')
            },
            onStatusChange(v) {
                this.ruleForm.status = v
                this.$refs.ruleForm.validateField('status')
            },
            onPriorityChange(v) {
                this.ruleForm.priority = v
                this.$refs.ruleForm.validateField('priority')
            },
            onRelatedIssueChange(v) {
                this.ruleForm.relatedIssue = v
                this.$refs.ruleForm.validateField('relatedIssue')
            },
            initFileList(list) {
                list.forEach((i, n) => {
                    i.name = i.uploadBy + '-' + i.name
                })
                return list
            }
        },
        mounted() {
            this.headers = {
                Authorization: sessionStorage.getItem('JSESSIONID'),
                siteClassification: sessionStorage.getItem('siteClassification')
            }
            this.statusList = this.data.statusDict
            this.selectOrganization()
            this.selectKPOwner()
            this.selectClientOwner()
            this.selectRelatedIssue()
            if (!_.isEmpty(this.data.formData)) {
                this.ruleForm = {
                    ...this.data.formData
                }
                const listF = JSON.parse(JSON.stringify(this.data.formData.attachmentList))
                this.fileList = this.initFileList(listF)
            }
            if (this.data.commentList) {
                this.commentList = this.data.commentList
            }
            this.getFileName()
            this.getcategoryOptions()
        },
        props: {
            onAddOrEdit: Function,
            onCancel: Function,
            onRefresh: Function,
            defaultValue: Object,
            data: Object
        },
        components: {
            SelectMulti,
            SelectAd,
            MComments
        }
    }
</script>
<style scoped>
  .wl-form-item {
    width: 230px;
  }

  .wl-matter-log-add-edit-container {
    background: #f0f0f0;
    padding: 12px;
    overflow: auto;
    height: 100%;
  }

  .formCenter {
    background: #fff;
    padding: 8px 0;
    border-radius: 2px;
  }

  .wl-ruleForm {
    margin-left: -30px;
  }
  ::v-deep .wl-form .el-form-item__label{
    font-size: 14PX;
  }
  ::v-deep .wl-form.el-form .el-form-item .el-form-item__content .el-input .el-input__inner,
  ::v-deep .wl-form.el-form .el-select .el-select__tags .el-tag,
  ::v-deep .wl-form.el-form .el-textarea .el-textarea__inner {
    font-size: 14PX;
  }
  .wl-matter-log-add-edit-btns {
    padding: 0 12px;
    margin-bottom: 12px;
    text-align: right;
  }

  .upload-demo {
    width: 720px;
  }
</style>
